<div class="custom-dialog-content">
  {{ message }}
</div>